var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "question-list-details" },
    [
      _c(
        "draggable",
        {
          staticClass: "questions",
          attrs: {
            "ghost-class": "ghost",
            disabled: _vm.mode === "readonly" || !!_vm.questionSearchMatcher
          },
          model: {
            value: _vm.questionList,
            callback: function($$v) {
              _vm.questionList = $$v
            },
            expression: "questionList"
          }
        },
        _vm._l(_vm.questionList, function(question, index) {
          return _c(
            "b-row",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    !_vm.questionSearchMatcher ||
                    _vm.questionSearchMatcher(question),
                  expression:
                    "!questionSearchMatcher || questionSearchMatcher(question)"
                }
              ],
              key: question._id,
              class:
                "question-item detail " +
                (_vm.calculatedMode === "readonly" && "readonly"),
              attrs: { "no-gutters": "" }
            },
            [
              _c("QuestionDetailItem", {
                attrs: {
                  question: question,
                  "question-number": index + 1,
                  mode: _vm.calculatedMode,
                  visible: _vm.visible,
                  "toggle-key": _vm.toggleKey
                }
              })
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }